import { render, staticRenderFns } from "./MigrationList.vue?vue&type=template&id=1f37f584&scoped=true"
import script from "./MigrationList.vue?vue&type=script&lang=js"
export * from "./MigrationList.vue?vue&type=script&lang=js"
import style0 from "./MigrationList.vue?vue&type=style&index=0&id=1f37f584&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37f584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f37f584')) {
      api.createRecord('1f37f584', component.options)
    } else {
      api.reload('1f37f584', component.options)
    }
    module.hot.accept("./MigrationList.vue?vue&type=template&id=1f37f584&scoped=true", function () {
      api.rerender('1f37f584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Migration/MigrationList.vue"
export default component.exports